<app-header></app-header>
<section class="hero-slider">
  <div class="slider-container">
    <div
      class="slide"
      *ngFor="let slide of slides; let i = index"
      [class.active]="i === currentSlide"
    >
      <ng-container *ngIf="slide.type === 'image'">
        <img [src]="slide.src" alt="Slide Image" />
      </ng-container>
      <ng-container *ngIf="slide.type === 'video'">
        <video
          #videoPlayer
          [src]="slide.src"
          muted
          autoplay
          loop
          playsinline
          webkit-playsinline
          preload="auto"
        ></video>
      </ng-container>
    </div>

    <!-- Navigation -->
    <button class="nav prev" (click)="prevSlide()">
      <span class="spanPrev">‹</span>
    </button>
    <button class="nav next" (click)="nextSlide()">
      <span class="spanNext">›</span>
    </button>

    <!-- Indicators -->
    <div class="indicators">
      <label
        *ngFor="let slide of slides; let i = index"
        class="indicator"
        [class.active]="i === currentSlide"
      >
        <input
          type="radio"
          name="slider"
          [checked]="i === currentSlide"
          (click)="goToSlide(i)"
        />
        <span (click)="goToSlide(i)"></span>
      </label>
    </div>
  </div>
</section>
<section id="video-learning" class="skills video-learning">
  <!-- HERO OVERLAY -->
  <div class="hero-overlay" *ngIf="!UtypeFlag && isLoggedIn">
    <div
      class="course-wide-card"
      (click)="navgate(traininCourses?.trainingCourseName)"
    >
      <div class="course-content" style="text-align: left">
        <span class="course-tag">{{
          traininCourses?.trainingCourseSkill
        }}</span>

        <h3>{{ traininCourses?.trainingCourseName }}</h3>

        <p class="course-desc">
          {{ traininCourses?.trainingCourseshortDesc }}
        </p>
        <div
          class="course-points"
          [innerHtml]="traininCourses?.trainingCoursePoint"
        >
          <!-- <ul>
            <li>Essential phonics concepts for early learners</li>
            <li>Hands-on classroom strategies</li>
            <li>Confidence building for educators</li>
          </ul> -->
        </div>

        <button class="course-btn">Get Started</button>
      </div>

      <div class="course-media">
        <img src="Main-Image.png" alt="Phonics Foundations" />
      </div>
    </div>
  </div>
  <div class="hero-overlay" *ngIf="!isLoggedIn">
    <div
      class="course-wide-card"
      (click)="openLoginModal()"
    >
      <div class="course-content" style="text-align: left">
        <span class="course-tag">{{
          traininCourses?.trainingCourseSkill
        }}</span>

        <h3>{{ traininCourses?.trainingCourseName }}</h3>

        <p class="course-desc">
          {{ traininCourses?.trainingCourseshortDesc }}
        </p>
        <div
          class="course-points"
          [innerHtml]="traininCourses?.trainingCoursePoint"
        >
          <!-- <ul>
            <li>Essential phonics concepts for early learners</li>
            <li>Hands-on classroom strategies</li>
            <li>Confidence building for educators</li>
          </ul> -->
        </div>

        <button class="course-btn">Enroll now</button>
      </div>

      <div class="course-media">
        <img src="Main-Image.png" alt="Phonics Foundations" />
      </div>
    </div>
  </div>
   <div class="hero-overlay" *ngIf="UtypeFlag && isLoggedIn">
    <div
      class="course-wide-card"
      (click)="showAlert()"
    >
      <div class="course-content" style="text-align: left">
        <span class="course-tag">{{
          traininCourses?.trainingCourseSkill
        }}</span>

        <h3>{{ traininCourses?.trainingCourseName }}</h3>

        <p class="course-desc">
          {{ traininCourses?.trainingCourseshortDesc }}
        </p>
        <div
          class="course-points"
          [innerHtml]="traininCourses?.trainingCoursePoint"
        >
          <!-- <ul>
            <li>Essential phonics concepts for early learners</li>
            <li>Hands-on classroom strategies</li>
            <li>Confidence building for educators</li>
          </ul> -->
        </div>

        <button class="course-btn">Get Started</button>
      </div>

      <div class="course-media">
        <img src="5.png" alt="Phonics Foundations" />
      </div>
    </div>
  </div>
</section>
<!-- <section class="skills video-learning">
  <div class="video-wrapper bg-video">
    
    <video autoplay muted loop playsinline poster="kidslap.jpeg">
      <source src="learning-preview.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video> -->

<!-- Overlay Content -->
<!-- <div class="video-overlay">
      <h2>Learn Anytime, Anywhere</h2>
      <p>
        Watch expert-led lessons and classroom-ready strategies designed for
        modern educators.
      </p>

      <a
        href="https://your-learning-link.com"
        target="_blank"
        class="video-btn"
      >
        Start Learning ▶
      </a>
    </div>
  </div>
</section> -->
<div class="card-container">

  <div class="card">
    <div class="card-icon">🚀</div>
    <div class="card-title">Live Training</div>
    <div class="card-desc">
      Enhance your teaching skills with expert-led live training sessions. Learn modern teaching methods, classroom management strategies, and practical techniques to deliver impactful lessons and improve student outcomes
    </div>
    <button *ngIf="!UtypeFlag && isLoggedIn" class="card-btn" (click)="navgate(traininCourses?.trainingCourseName)">Access Live Training</button>
    <button *ngIf="!isLoggedIn" class="card-btn" (click)="openLoginModal()">Access Live Training</button>
    <button *ngIf="UtypeFlag && isLoggedIn" class="card-btn" (click)="showAlert()">Access Live Training</button>
  </div>

  <div class="card">
    <div class="card-icon">📚</div>
    <div class="card-title">Courses</div>
    <div class="card-desc">
      Access structured courses designed to help teachers master modern teaching methods, classroom management, lesson planning, and student engagement techniques
    </div>
    <button class="card-btn" (click)="goToCourses()">Explore All Courses</button>
  </div>

  <div class="card">
    <div class="card-icon">🎯</div>
    <div class="card-title">Practice</div>
    <div class="card-desc">
     Apply your knowledge through real-world teaching exercises, lesson simulations, and practical activities to strengthen your classroom skills and confidence
    </div>
    <button class="card-btn">Access Practice Module</button>
  </div>


</div>

<section class="success-stories">
  <div class="container">
    <div class="section-title">
      <h2>See What Educators Are Achieving</h2>
      <p>
        Join thousands of early childhood educators who are transforming their
        classrooms with Kaboodle.
      </p>
    </div>

    <div class="survey-badge">
      <div>
        <strong
          >Kaboodle was rated the most effective professional development
          program for early years educators according to the 2023 ECE
          Survey.</strong
        >
      </div>
      <img
        src="https://dummyimage.com/150x50/45c3c6/ffffff&text=ECE+Survey"
        alt="ECE Survey Logo"
      />
    </div>

    <div class="stories-grid">
      <div class="story-card">
        <p>
          "Kaboodle helped me completely transform my approach to assessment.
          The differentiated rubrics saved me hours of work each week while
          providing better insights into student progress."
        </p>
        <div class="story-author" data-initial="S">Ms. Sunita Sharma</div>
        <div class="story-position">Nursery Teacher, Delhi Public School</div>
        <!-- <a class="story-link">View Assessment Courses →</a> -->
      </div>

      <div class="story-card">
        <p>
          "The multiple intelligences framework from Kaboodle helped me reach
          every child in my classroom. I now have activities tailored for
          visual, auditory, and kinesthetic learners."
        </p>
        <div class="story-author" data-initial="A">Ms. Aditi Patel</div>
        <div class="story-position">Preschool Director, Mumbai</div>
        <!-- <a class="story-link">View Teaching Strategies →</a> -->
      </div>

      <div class="story-card">
        <p>
          "With Kaboodle's IRRA formula, I spend less time preparing and more
          time engaging with my students. The ready-to-use activities are a
          game-changer for busy teachers."
        </p>
        <div class="story-author" data-initial="R">Mr. Rajiv Menon</div>
        <div class="story-position">ECE Coordinator, Bangalore</div>
        <!-- <a class="story-link">View Activity Library →</a> -->
      </div>
      <div class="story-card">
        <p>
          "Thank you to the Kaboodle team for creating a helpful app that reduced teachers workload. my children were very excited to sing "see you later alligator", and recently watching elmor the elephant story. "
        </p>
        <div class="story-author" data-initial="P">Ms. Priya Subramani</div>
        <div class="story-position">Teacher, Air Force School, Chimney Hills.</div>
        <!-- <a class="story-link">View Activity Library →</a> -->
      </div>
      <div class="story-card">
        <p>
          "The lesson plans are so easy to use, the planning is hassle free now.
           Everything is given in the Kaboodle app and we are happily using the app.
           Anima Saha Bearder "
        </p>
        <div class="story-author" data-initial="A">Ms. Anima Saha Bearder</div>
        <div class="story-position">Coordinator, Douglas Memorial School, West Bengal</div>
        <!-- <a class="story-link">View Activity Library →</a> -->
      </div>
      <div class="story-card">
        <p>
          "The syllabus is perfectly designed, especially the characters, Doodle and Noodle, are loved by the students."
        </p>
        <div class="story-author" data-initial="I">Ms. Iqra</div>
        <div class="story-position">Coordinator, SRM Welkin Sopore, Jammu</div>
        <!-- <a class="story-link">View Activity Library →</a> -->
      </div>
    </div>
  </div>
</section>

<!-- <section class="career-accelerator">
  <div class="container">
    <h2>Skills That Advance Your Teaching Career</h2>
    <p>
      Introducing Educator Accelerators – focus on the teaching skills and
      classroom experience that will get you recognized as an exceptional early
      years educator.
    </p>
    <a class="btn btn-outline" style="color: white; border-color: white">Explore Educator Accelerators</a>
  </div>
</section> -->

<section class="stats">
  <div class="container">
    <div class="section-title">
      <h2 class="text-align">Why Early Years Matter</h2>
      <p class="text-align">
        90% of brain development happens by age 6 – make every moment count with
        evidence-based teaching strategies
      </p>
    </div>

    <div class="stats-grid">
      <div class="stat-item">
        <h3>90%</h3>
        <p>Brain developed by age 6</p>
      </div>

      <div class="stat-item">
        <h3>2x</h3>
        <p>More neural connections than adults</p>
      </div>

      <div class="stat-item">
        <h3>1M/sec</h3>
        <p>New synapses formed ages 3-6</p>
      </div>

      <div class="stat-item">
        <h3>25hr</h3>
        <p>Course to transform your teaching</p>
      </div>
    </div>
  </div>
</section>

<section class="cta">
  <div class="container">
    <h2>Ready to Reimagine Your Early Years Classroom?</h2>
    <p>
      Get the teaching skills and classroom-tested strategies that will make you
      an exceptional early childhood educator.
    </p>
    <!-- <a
      class="btn btn-primary"
     
      >Start Learning Today</a
    > -->
  </div>
</section>
<app-login #authModal (modalClosed)="onModalClosed()">
</app-login>
<app-footer></app-footer>
